import { useCallback, useState, type ReactElement } from 'react'
import * as S from './discount.styled'
import logoUltragaz from './assets/logo-ultragaz.png'
import logoDrograsil from './assets/logo-drogasil.png'
import logoRaia from './assets/logo-raia.png'
import check from '../../assets/images/check.svg'
import image1 from './assets/gas.png'
import DiscountAccordion from '../accordion/discount-accordion'

export function Discount (): ReactElement {
  const [activeAccordion, setActiveAccordion] = useState<number | undefined>(0)

  const handleOnOpen = useCallback((newIndex?: number): void => {
    if (newIndex !== undefined) {
      setActiveAccordion(newIndex)
    }
  }, [])

  return <S.Container>
    <S.Content>
      <S.TextContent>
        <h1>Conheça outros benefícios!</h1>
        <div>
          <DiscountAccordion
            index={0}
            isOpen={activeAccordion === 0}
            onOpen={handleOnOpen}
            title="botijão com um ultradesconto!"
            titleImages={[logoUltragaz]}
          >
            <S.AccordionContent>
              <span>Peça o seu gás pelo app com facilidade e frete gratuito!</span>
              <ul>
                <li>
                  <img src={check} alt="" />
                  <span><strong>Cashback de 12%</strong> no botijão Ultragaz.</span>
                </li>
                <li>
                  <img src={check} alt="" />
                  <span>Peça pelo app <strong>Cartão de TODOS</strong> com toda a segurança e sem sair de casa.</span>
                </li>
                <li>
                  <img src={check} alt="" />
                  Acompanhe o seu pedido desde a compra até a entrega.
                </li>
              </ul>
            </S.AccordionContent>
          </DiscountAccordion>
          <DiscountAccordion
            index={1}
            isOpen={activeAccordion === 1}
            onOpen={handleOnOpen}
            title="até 35% de desconto e dinheiro de volta!"
            titleImages={[logoDrograsil, logoRaia]}
          >
            <S.AccordionContent>
              <ul>
                <li>
                  <img src={check} alt="" />
                  Atendimento de qualidade e humanizado.
                </li>
                <li>
                  <img src={check} alt="" />
                  Agendamento pelo App. É rápido, é prático.
                </li>
                <li>
                  <img src={check} alt="" />
                  4.000 tipos de exames.
                </li>
              </ul>
            </S.AccordionContent>
          </DiscountAccordion>
        </div>
        <span><small>Além de descontos em milhares de lojas e estabelecimentos</small></span>
      </S.TextContent>
      <S.ImageContainer>
        {activeAccordion === 0 && <img src={image1} alt="" />}
        {activeAccordion === 1 && <img src={image1} alt="" />}
      </S.ImageContainer>
    </S.Content>
  </S.Container>
}
